var chunkMapping = {
	"195": [
		14195
	],
	"267": [
		4267
	],
	"300": [
		41300
	],
	"406": [
		96406
	],
	"500": [
		30500
	],
	"506": [
		45506
	],
	"620": [
		7620
	],
	"665": [
		15665
	],
	"693": [
		42693
	],
	"764": [
		1764
	],
	"775": [
		73775
	],
	"801": [
		71801
	],
	"929": [
		96929
	],
	"933": [
		79933
	],
	"950": [
		49950
	],
	"985": [
		15985
	]
};
var idToExternalAndNameMapping = {
	"1764": [
		"default",
		"./Sales",
		11255
	],
	"4267": [
		"default",
		"./VendorContacts",
		10315
	],
	"7620": [
		"default",
		"./Navbar",
		80723
	],
	"14195": [
		"default",
		"./ProductContent",
		90400
	],
	"15665": [
		"default",
		"./Login",
		84960
	],
	"15985": [
		"default",
		"./UserManagement",
		93506
	],
	"30500": [
		"default",
		"./AccountSettings",
		97514
	],
	"41300": [
		"default",
		"./Dashboard",
		21462
	],
	"42693": [
		"default",
		"./Invoices",
		53541
	],
	"45506": [
		"default",
		"./HelpCenter",
		91473
	],
	"49950": [
		"default",
		"./Faqs",
		96923
	],
	"71801": [
		"default",
		"./ProspectiveResource",
		70573
	],
	"73775": [
		"default",
		"./CatalogManagement",
		49480
	],
	"79933": [
		"default",
		"./NoCompany",
		80723
	],
	"96406": [
		"default",
		"./OrderManagement",
		22275
	],
	"96929": [
		"default",
		"./NotificationCenter",
		59388
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_modules__[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}